<ef-loading-container [observables]="[payrollItems$]"></ef-loading-container>
<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-payroll-item
    [showInactive]="showInactivePayrollItems"
    (showInactiveChange)="onShowInactiveChange($event)"
    [items]="payrollItems$ | async"
    [employeesPayrollItemsSelectItems]="employeesPayrollItemsSelectItems$ | async"
    [employeesSelectItems]="employeesSelectItems$ | async"
    [payrollItemsSelectItems]="payrollItemsSelectItems$ | async"
    [payrollItemTypesSelectItems]="payrollItemTypeSelectItems$ | async"
    [payCodeSelectItems]="payCodeSelectItems$ | async"
    [employees]="payrollItemEmployees$ | async"
    [accountSelectItems]="accountSelectItems$ | async"
    [laborTypes]="laborTypes$ | async"
    [selectedError]="selectedErrorWithStatus$ | async"
    [qbo]="quickbooksOnline$ | async"
    [externalIntegration]="externalIntegration$ | async"
    (SaveItem)="onSave($event)"
    (ShowError)="onShowError($event)"
    (SelectItem)="onSelect($event)"
></ef-payroll-item>
